import script from "./Molecule.vue?vue&type=script&setup=true&lang=js"
export * from "./Molecule.vue?vue&type=script&setup=true&lang=js"

import "./Molecule.vue?vue&type=style&index=0&id=2c446f80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c446f80"]])

export default __exports__